/**
 * To show different messages.
 */
enum MessageType {
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning",
  INFORMATION = "info",
}

export default MessageType;
